import { connect } from "react-redux";
import { Creators, getSelectedUserInQueue } from "../../../reducer";
import LaneCard from "./LaneCard";

export default connect(
  state => ({
    selectedUser: getSelectedUserInQueue(state),
    location: state.login.location
  }),
  dispatch => ({
    onAssignUserToLane: (location, range, laneNumber, selectedUser) =>
      dispatch(
        Creators.assignUserToLane(location, range, laneNumber, selectedUser)
      ),
    onOpenLaneDetail: (location, range, laneNumber, lane) =>
      dispatch(Creators.openLaneDetail(location, range, laneNumber, lane))
  })
)(LaneCard);



// WEBPACK FOOTER //
// ./src/staff/components/Range/LaneCard/index.js